import React, { useEffect, useState } from 'react';
import { Alert, Box, CircularProgress, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { chooseSubscription, getSubscriptions } from '../../services/subscribe';
import SubscribeCard from './SubscribeCard';

const SubscribeModal = ({ open, onClose, user, onChanged }) => {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) return;
    setBusy(true); setError('');
    getSubscriptions().then(setItems).catch((err) => setError(err.response?.data?.detail || 'Не удалось загрузить тарифы')).finally(() => setBusy(false));
  }, [open]);

  const select = async (id) => {
    setBusy(true); setError('');
    try { await chooseSubscription(id); await onChanged(); onClose(); }
    catch (err) { setError(err.response?.data?.detail || 'Не удалось выбрать тариф'); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onClose={busy ? undefined : onClose} maxWidth="md" fullWidth>
      <DialogTitle>Выберите тариф <IconButton onClick={onClose} sx={{ float: 'right' }}><Close /></IconButton></DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {busy && !items.length ? <Box py={6} textAlign="center"><CircularProgress /></Box> : (
          <Box display="grid" gridTemplateColumns={{ xs: '1fr', md: 'repeat(2,1fr)' }} gap={2} py={1}>
            {items.filter((item) => Number(item.price_per_day) > 0).map((item) => <SubscribeCard key={item.id} subscription={item} current={user?.subscribe_id === item.id} onSelect={select} busy={busy} />)}
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default SubscribeModal;
